import clsx from 'clsx'
import { Controller, useFormContext } from 'react-hook-form'
import ImageUploader from '../../ImageUploader/ImageUploader'
import { AdFormSchema } from '../AdForm/AdFormTypes'

interface AppleWalletImageProps {
  defaultImage?: string
  width?: number
  height?: number
}

const AppleWalletImage = ({ defaultImage, width, height }: AppleWalletImageProps) => {
  const {
    control,
    clearErrors,
    setError,
    formState: { errors },
  } = useFormContext<AdFormSchema>()

  return (
    <div
      className={clsx('bg-white rounded-md h-fit p-4', errors.passDetails?.appleWalletImage?.message && 'border-error')}
      data-testid="image-input"
    >
      <Controller
        control={control}
        name="passDetails.appleWalletImage"
        rules={{ required: 'Apple Wallet image is required.' }}
        render={({ field: { onChange } }) => (
          <ImageUploader
            subText="or drop an image to upload"
            criteria={`Image size ${width} x ${height} px (.jpg .png or .webp). Maximum 5MB.`}
            widthReq={width ?? 624}
            heightReq={height ?? 246}
            defaultImg={defaultImage || ''}
            imageUrlCB={onChange}
            setErrorAdvert={error => setError('passDetails.appleWalletImage', error)}
            clearErrorsAdvert={clearErrors}
            imgType="APPLE_WALLET_IMAGE"
            formError={errors.passDetails?.appleWalletImage?.message ?? ''}
          />
        )}
      />
    </div>
  )
}

export default AppleWalletImage
